import {
  createColumnHelper,
  getCoreRowModel,
  getFacetedMinMaxValues,
  getFacetedRowModel,
  getFacetedUniqueValues,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  useReactTable,
} from '@tanstack/react-table';
import PaginatedTable from '../Common/PaginatedTable';
import { HiPencilAlt, HiXCircle } from 'react-icons/hi';
import { WarrantyPhoto } from '../../Models/WarrantyPhoto';

export default function WarrantyPhotosTable({
  data,
  editWarrantyPhoto,
  deleteWarrantyPhoto,
}: {
  data: WarrantyPhoto[];
  editWarrantyPhoto: (labor: WarrantyPhoto) => void;
  deleteWarrantyPhoto(photo: WarrantyPhoto): void;
}) {
  const columnHelper = createColumnHelper<WarrantyPhoto>();

  const columns = [
    columnHelper.accessor((row) => row.id, {
      id: 'id',
      header: '',
      cell: (info) => (
        <div className='flex justify-center gap-1'>
          <button
            type='button'
            className='buttonMain p-2'
            onClick={() => editWarrantyPhoto(info.row.original)}
          >
            <HiPencilAlt />
          </button>
          <button
            type='button'
            className='buttonCancel p-2'
            onClick={() => deleteWarrantyPhoto(info.row.original)}
          >
            <HiXCircle />
          </button>
        </div>
      ),
      footer: (info) => info.column.id,
      size: 35,
      enableColumnFilter: false,
    }),
    columnHelper.accessor((row) => row.photoUrl, {
      id: 'photoUrl',
      header: 'Image',
      cell: (info) => (
        <img
          key={info.row.original.id}
          src={info.getValue() ?? ''}
          className='h-[75px] object-contain'
        />
      ),
      enableColumnFilter: false,
    }),
    columnHelper.accessor((row) => row.notes, {
      id: 'notes',
      header: 'Notes',
      enableColumnFilter: false,
    }),
  ];

  const table = useReactTable({
    data,
    columns,
    getSortedRowModel: getSortedRowModel(),
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getFacetedRowModel: getFacetedRowModel(),
    getFacetedUniqueValues: getFacetedUniqueValues(),
    getFacetedMinMaxValues: getFacetedMinMaxValues(),
    // Claim form tables hide the pager; show every row (TanStack default pageSize is 10).
    state: {
      pagination: {
        pageIndex: 0,
        pageSize: Math.max(data.length, 1),
      },
    },
  });

  return (
    <>
      <div className='w-full mx-auto overflow-x-auto'>
        <PaginatedTable
          table={table}
          dataCount={data.length}
          columnResizeMode='onChange'
          showFilters={true}
          showPagination={false}
        />
      </div>
    </>
  );
}
